module.exports = __webpack_public_path__ + "media/Article/Article1-3a15618c.png";